/**
 * @generated SignedSource<<f38f7d7dcfaa2ac24a6d9b8bcf7c51b3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type PackageStatus = "DRAFT" | "EXPIRED" | "PUBLISHED" | "WAITING";
import { FragmentRefs } from "relay-runtime";
export type PackageListRow_package$data = {
  readonly createdAt: string | null;
  readonly createdBy: {
    readonly name: string;
  } | null;
  readonly id: string;
  readonly name: string;
  readonly price: number | null;
  readonly status: PackageStatus;
  readonly updatedAt: string | null;
  readonly updatedBy: {
    readonly name: string;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"EntityTableRow_entity" | "PackageStatus_package">;
  readonly " $fragmentType": "PackageListRow_package";
};
export type PackageListRow_package$key = {
  readonly " $data"?: PackageListRow_package$data;
  readonly " $fragmentSpreads": FragmentRefs<"PackageListRow_package">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v1 = [
  (v0/*: any*/)
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PackageListRow_package",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "price",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "updatedAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "createdBy",
      "plural": false,
      "selections": (v1/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "updatedBy",
      "plural": false,
      "selections": (v1/*: any*/),
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "EntityTableRow_entity"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PackageStatus_package"
    }
  ],
  "type": "Package",
  "abstractKey": null
};
})();

(node as any).hash = "71b4a863bdd8575f4026da0e51ed6c70";

export default node;
